'use strict';
const angular = require('angular');
import { extendedCRUDMethods } from './extendedCRUDMethods';

export default function ShopResource($resource) {
  'ngInject';
  // /shops/:id/reports/:reportId/before
  return $resource(
    '/api/shops/:id/:resource',
    { id: '@_id' },
    Object.assign({}, extendedCRUDMethods, {
      currentDailyReport: {
        method: 'GET',
        params: { id: '@_id', resource: 'currentDailyReport' }
      }
    })
  );
}



// WEBPACK FOOTER //
// ./client/components/resources/shop.resource.ts